import React, {useState, useEffect} from 'react';
import {Container, Tabs, Tab} from 'react-bootstrap';
import MetricConfigForm from './MetricConfigForm';
// import MetricDisplay from './MetricDisplay';
import CustomRuleManager from "./CustomRuleManager";
import './UserPanel.css';

const MetricConfigTabs = () => {
    const [activeKey, setActiveKey] = useState("addMetric");

    useEffect(() => {
        const switchToCustomRule = () => setActiveKey("customRule");
        window.addEventListener("switch-to-custom-rule", switchToCustomRule);
        return () => window.removeEventListener("switch-to-custom-rule", switchToCustomRule);
    }, []);

    return (
        <Container>
            <Tabs
                id="metric-config-tabs"
                activeKey={activeKey}
                onSelect={(k) => setActiveKey(k || "addMetric")}
                className="mb-3 my-dark-tabs"
            >
                {/*<Tab eventKey="addMetric" title="Add Metric">*/}
                {/*    <MetricConfigForm/>*/}
                {/*</Tab>*/}
                <Tab eventKey="customRule" title="Custom Rule Manager">
                    <CustomRuleManager/>
                </Tab>
                {/*<Tab eventKey="viewMetrics" title="View Metrics">*/}
                {/*    <MetricDisplay/>*/}
                {/*</Tab>*/}
            </Tabs>
        </Container>
    );
};

export default MetricConfigTabs;
